export default [
    {
        name : "Sıra",
        id : "os1" 
    },
    {
        name : "Masa",
        id : "os2"
    },
    {
        name : "Ofisiant",
        id : "os3"
    },
    {
        name : "Status",
        id : "os4"
    },
    {
        name : "Qiymət",
        id : "os5"
    },
    {
        name : "Tarix",
        id : "os6"
    }
];